import { useState } from 'react';

import { ContentDialog, DifficultyBadge } from '@opositandopn/ui';

import { Page } from '../../components/shared/page/Page';
import { useProfile } from '../../context/ProfileContext';
import { useGetTrainingPlan } from '../../features/physical-tests/api/usePhysicalTests';
import { TrainingPlanList } from '../../features/physical-tests/components/training-plan-list/TrainingPlanList';
import { useAppActions } from '../../state/appStore';

import styles from './PhysicalTestsTrainingPlansPage.module.scss';

function PhysicalTestsTrainingPlansPage() {
  const { profile } = useProfile();
  const { setShowGetPremiumPopup } = useAppActions();
  const isPremium = !!profile.subscription?.isActive;

  const [currentId, setCurrentId] = useState<string>();

  const { data: current } = useGetTrainingPlan(
    currentId ?? '',
    currentId !== undefined,
  );

  return (
    <Page title="Planes de entrenamiento">
      <TrainingPlanList
        onSelected={(trainingPlan) => {
          if (!isPremium) {
            setShowGetPremiumPopup(true);
            return;
          }
          setCurrentId(trainingPlan.id);
        }}
      />
      <ContentDialog
        className={styles['dialog']}
        open={currentId !== undefined}
        title={current?.name}
        loading={currentId !== undefined && current === undefined}
        onClose={() => setCurrentId(undefined)}
        tooltip="Estos entrenamientos son de carácter general y pueden no adaptarse a tus necesidades. Consulta con tu entrenador o profesional cualificado para asegurarte de que son adecuados para ti."
      >
        {current ? (
          <div className={styles['content']}>
            <div className={styles['badge']}>
              <DifficultyBadge difficulty={current.difficultyLevel} />
            </div>
            <div
              className={styles['description']}
              dangerouslySetInnerHTML={{ __html: current.description }}
            />
          </div>
        ) : (
          ''
        )}
      </ContentDialog>
    </Page>
  );
}

export { PhysicalTestsTrainingPlansPage };
